import { Badge } from '@/shared/ui/Badge';

import type { Email } from './types';

/**
 * «Respondido» (contract v10.43, ADR 0037 of the back): a reply went out, from here or
 * from the mail client, which the mailbox marks `\Answered` like Thunderbird's arrow. A
 * fact, not a state of the triage: it does not take the email out of «Por revisar». An
 * older back sends no `answered_at`, and then nothing shows. No date: for what was already
 * answered in Thunderbird when the platform first read the mailbox, `answered_at` is the
 * day it noticed, not the day of the reply.
 */
export function AnsweredBadge({ email }: { email: Pick<Email, 'answered_at'> }) {
  if (!email.answered_at) return null;
  return (
    <Badge tone="neutral" title="Ya se respondió, desde aquí o desde el programa de correo.">
      Respondido
    </Badge>
  );
}
